import { useCallback } from 'react';
import NovaraFC from '../components/NovaraFC';
import { fcUatAPI } from '../services/api';

/**
 * FC UAT page — mounts Paul's Novara-FC UAT build (iframe) and captures its
 * `complete` payload to the advisory capture endpoint. UAT only; the build scores
 * client-side, so nothing here is measurement.
 */
export default function FcUatPage() {
  const handleComplete = useCallback((payload) => {
    // Best-effort advisory capture; a failure must not disrupt the learner's UAT run.
    fcUatAPI.captureResult(payload).catch((err) => {
      // eslint-disable-next-line no-console
      console.warn('FC UAT result capture failed (advisory only):', err?.message || err);
    });
  }, []);

  return <NovaraFC onComplete={handleComplete} />;
}
